import { DateTime } from 'luxon'

export default {
  install: (app) => {
    app.config.globalProperties.$helpers = {
      moveItemUp(item, collection) {
        const index = collection.indexOf(item)
        collection.splice(index, 1)
        collection.splice(index - 1, 0, item)
      },
      moveItemDown(item, collection) {
        const index = collection.indexOf(item)
        collection.splice(index, 1)
        collection.splice(index + 1, 0, item)
      },
      removeItem(item, collection) {
        const index = collection.indexOf(item)
        if (index >= 0) {
          collection.splice(collection.indexOf(item), 1)
        }
      },
      isValidUrl(url) {
        return /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+(:[0-9]+)?|(?:www.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)/.test(
          url
        )
      },
      sanitiseVideoUrl(url) {
        let matches = /^https?:\/\/(?:www.)?(?:youtu.be\/|youtube.com\/watch\?.*v=)([a-zA-z0-9_-]+)/.exec(url)
        if (matches?.length > 0) {
          return `https://www.youtube.com/embed/${matches[1]}`
        }
        matches =
          /^https?:\/\/(?:www.|player.)?vimeo.com(?:\/.*\/review|\/.*\/download|\/video|\/external)?\/(\d*)/.exec(url)
        if (matches?.length > 0) {
          return `https://player.vimeo.com/video/${matches[1]}`
        }

        return url
      },
      isBefore(date1, date2, inclusive = false) {
        if (!date1 || !date2) {
          return false
        }

        date1 = DateTime.fromISO(date1)
        date2 = DateTime.fromISO(date2)

        return inclusive ? date1 <= date2 : date1 < date2
      },
      isAfter(date1, date2, inclusive = false) {
        if (!date1 || !date2) {
          return false
        }

        date1 = DateTime.fromISO(date1)
        date2 = DateTime.fromISO(date2)

        return inclusive ? date1 >= date2 : date1 > date2
      },
      isPast(date) {
        return date && DateTime.fromISO(date) <= DateTime.utc()
      },
      isFuture(date) {
        return date && DateTime.fromISO(date) > DateTime.utc()
      },
      dateDiff(date1, date2 = 'now') {
        if (!date1) {
          return 0
        }

        date1 = DateTime.fromISO(date1)
        date2 = date2 === 'now' ? DateTime.utc() : DateTime.fromISO(date2)

        return Math.abs(Math.round(date1.diff(date2, 'seconds').toObject().seconds))
      }
    }
  }
}
